module.exports = __webpack_public_path__ + "media/images/check-2a4f5c663503c3f4d4a95327c8f7893f.png";